var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSurvey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 160,
  height: 161,
  viewBox: "0 0 160 161",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M72.142 48.84c-22.24 1.896-41.39 5.893-62.393 11.298-4.016 1.038-8.575 2.737-8.946 5.696-.346 2.687 3.027 4.85 6.215 6.4a111.588 111.588 0 0 0 14.326 5.751c3.824 1.236 8.03 2.471 10.267 4.942 3.429 3.707.939 8.828-3.336 12.108-4.275 3.28-10.05 5.418-14.684 8.457-3.75 2.471-6.795 6.376-4.281 9.49 2.193 2.686 7.32 3.28 11.737 3.551 41.026 2.52 83.713 2.718 121.767-8.197 7.574-2.169 15.87-5.702 16.587-11.349.575-4.534-4.127-8.562-9.174-11.478-5.047-2.915-10.897-5.424-14.177-9.37-3.04-3.664-3.447-8.088-5.708-12.01-4.615-8.03-11.027-8.6-23.296-10.249-12.27-1.65 34.421-8.45-34.904-5.04Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M92.355 139.94c26.536 0 48.049-2.754 48.049-6.153 0-3.398-21.513-6.153-48.05-6.153-26.536 0-48.048 2.755-48.048 6.153 0 3.399 21.512 6.153 48.049 6.153Z",
  fill: "url(#b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M50.02 99.49 37.968 67.723 74.144 89.21 50.02 99.49Z",
  fill: "url(#c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M84.837 82.34c.117-1.173 3.324-38.45 4.714-37.01 1.39 1.44 19.94 31.586 19.94 31.586L84.837 82.34Z",
  fill: "url(#d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M126.727 87a4.653 4.653 0 0 0-3.169-4.413l-7.734-63.178S95.753 76.243 95.598 77.973c-.154 1.73-37.529-36.646-37.529-36.646l.445 49.31L0 73.487l33.89 45.715a4.665 4.665 0 0 0 4.8 6.48l5.437 7.333c33.717-27.873 81.334-34.91 81.334-34.91l-.883-7.209a4.654 4.654 0 0 0 2.15-3.898l-.001.001Z",
  fill: "#0AC39B"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M44.127 133.034s10.7-.056 43.385-13.74c32.686-13.683 37.949-21.17 37.949-21.17s-17.297 1.446-43.478 11.738c-26.18 10.291-37.856 23.172-37.856 23.172Z",
  fill: "url(#e)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M52.49 115.019a3.564 3.564 0 1 0 .002-7.127 3.564 3.564 0 0 0-.001 7.127Z",
  fill: "url(#f)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M107.657 92.261a3.564 3.564 0 1 0 0-7.128 3.564 3.564 0 0 0 0 7.128Z",
  fill: "url(#g)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M78.56 102.8a4.676 4.676 0 1 0 .002-9.351 4.676 4.676 0 0 0-.001 9.351Z",
  fill: "url(#h)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M53.677 113.067a3.564 3.564 0 1 0 .001-7.127 3.564 3.564 0 0 0 0 7.127ZM108.843 90.315a3.564 3.564 0 1 0 0-7.127 3.564 3.564 0 0 0 0 7.127ZM79.747 100.854a4.676 4.676 0 1 0 .001-9.351 4.676 4.676 0 0 0 0 9.351Z",
  fill: "#008C78"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.778,
  y1: 82.928,
  x2: 159.476,
  y2: 82.928,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C6EBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DDF4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 44.306,
  y1: 133.787,
  x2: 140.404,
  y2: 133.787,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3C4045"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3C4045",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 43.995,
  y1: 83.612,
  x2: 60.936,
  y2: 88.631,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0AC39B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#008C78"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 93.524,
  y1: 63.823,
  x2: 100.204,
  y2: 73.207,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0AC39B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#008C78"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 87.382,
  y1: 89.365,
  x2: 175.808,
  y2: 89.365,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0AC39B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#008C78"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 49.557,
  y1: 120.992,
  x2: 53.232,
  y2: 109.04,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3C4045"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3C4045",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 104.723,
  y1: 98.24,
  x2: 108.398,
  y2: 86.288,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3C4045"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3C4045",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 74.706,
  y1: 110.658,
  x2: 79.537,
  y2: 94.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3C4045"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3C4045",
  stopOpacity: 0.1
})))));
export { SvgSurvey as ReactComponent };
export default "data:image/svg+xml,%3csvg width='160' height='161' viewBox='0 0 160 161' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M72.142 48.84c-22.24 1.896-41.39 5.893-62.393 11.298-4.016 1.038-8.575 2.737-8.946 5.696-.346 2.687 3.027 4.85 6.215 6.4a111.588 111.588 0 0 0 14.326 5.751c3.824 1.236 8.03 2.471 10.267 4.942 3.429 3.707.939 8.828-3.336 12.108-4.275 3.28-10.05 5.418-14.684 8.457-3.75 2.471-6.795 6.376-4.281 9.49 2.193 2.686 7.32 3.28 11.737 3.551 41.026 2.52 83.713 2.718 121.767-8.197 7.574-2.169 15.87-5.702 16.587-11.349.575-4.534-4.127-8.562-9.174-11.478-5.047-2.915-10.897-5.424-14.177-9.37-3.04-3.664-3.447-8.088-5.708-12.01-4.615-8.03-11.027-8.6-23.296-10.249-12.27-1.65 34.421-8.45-34.904-5.04Z' fill='url(%23a)'/%3e%3cpath opacity='.15' d='M92.355 139.94c26.536 0 48.049-2.754 48.049-6.153 0-3.398-21.513-6.153-48.05-6.153-26.536 0-48.048 2.755-48.048 6.153 0 3.399 21.512 6.153 48.049 6.153Z' fill='url(%23b)'/%3e%3cpath d='M50.02 99.49 37.968 67.723 74.144 89.21 50.02 99.49Z' fill='url(%23c)'/%3e%3cpath d='M84.837 82.34c.117-1.173 3.324-38.45 4.714-37.01 1.39 1.44 19.94 31.586 19.94 31.586L84.837 82.34Z' fill='url(%23d)'/%3e%3cpath d='M126.727 87a4.653 4.653 0 0 0-3.169-4.413l-7.734-63.178S95.753 76.243 95.598 77.973c-.154 1.73-37.529-36.646-37.529-36.646l.445 49.31L0 73.487l33.89 45.715a4.665 4.665 0 0 0 4.8 6.48l5.437 7.333c33.717-27.873 81.334-34.91 81.334-34.91l-.883-7.209a4.654 4.654 0 0 0 2.15-3.898l-.001.001Z' fill='%230AC39B'/%3e%3cpath d='M44.127 133.034s10.7-.056 43.385-13.74c32.686-13.683 37.949-21.17 37.949-21.17s-17.297 1.446-43.478 11.738c-26.18 10.291-37.856 23.172-37.856 23.172Z' fill='url(%23e)'/%3e%3cpath opacity='.5' d='M52.49 115.019a3.564 3.564 0 1 0 .002-7.127 3.564 3.564 0 0 0-.001 7.127Z' fill='url(%23f)'/%3e%3cpath opacity='.5' d='M107.657 92.261a3.564 3.564 0 1 0 0-7.128 3.564 3.564 0 0 0 0 7.128Z' fill='url(%23g)'/%3e%3cpath opacity='.5' d='M78.56 102.8a4.676 4.676 0 1 0 .002-9.351 4.676 4.676 0 0 0-.001 9.351Z' fill='url(%23h)'/%3e%3cpath d='M53.677 113.067a3.564 3.564 0 1 0 .001-7.127 3.564 3.564 0 0 0 0 7.127ZM108.843 90.315a3.564 3.564 0 1 0 0-7.127 3.564 3.564 0 0 0 0 7.127ZM79.747 100.854a4.676 4.676 0 1 0 .001-9.351 4.676 4.676 0 0 0 0 9.351Z' fill='%23008C78'/%3e%3cdefs%3e%3clinearGradient id='a' x1='.778' y1='82.928' x2='159.476' y2='82.928' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23C6EBFF'/%3e%3cstop offset='1' stop-color='%23DDF4FF'/%3e%3c/linearGradient%3e%3clinearGradient id='b' x1='44.306' y1='133.787' x2='140.404' y2='133.787' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%233C4045'/%3e%3cstop offset='1' stop-color='%233C4045' stop-opacity='.1'/%3e%3c/linearGradient%3e%3clinearGradient id='c' x1='43.995' y1='83.612' x2='60.936' y2='88.631' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%230AC39B'/%3e%3cstop offset='1' stop-color='%23008C78'/%3e%3c/linearGradient%3e%3clinearGradient id='d' x1='93.524' y1='63.823' x2='100.204' y2='73.207' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%230AC39B'/%3e%3cstop offset='1' stop-color='%23008C78'/%3e%3c/linearGradient%3e%3clinearGradient id='e' x1='87.382' y1='89.365' x2='175.808' y2='89.365' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%230AC39B'/%3e%3cstop offset='1' stop-color='%23008C78'/%3e%3c/linearGradient%3e%3clinearGradient id='f' x1='49.557' y1='120.992' x2='53.232' y2='109.04' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%233C4045'/%3e%3cstop offset='1' stop-color='%233C4045' stop-opacity='.1'/%3e%3c/linearGradient%3e%3clinearGradient id='g' x1='104.723' y1='98.24' x2='108.398' y2='86.288' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%233C4045'/%3e%3cstop offset='1' stop-color='%233C4045' stop-opacity='.1'/%3e%3c/linearGradient%3e%3clinearGradient id='h' x1='74.706' y1='110.658' x2='79.537' y2='94.956' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%233C4045'/%3e%3cstop offset='1' stop-color='%233C4045' stop-opacity='.1'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";